<script setup lang="ts">
import UiCmsRichText from './UiCmsRichText.vue';
import type { CmsUiRow } from './uiCmsRow';

defineOptions({
  name: 'UiCmsRow',
});

defineProps({
  data: {
    type: Object as PropType<CmsUiRow>,
    required: true,
  },
});
</script>

<template>
  <div v-storyblok-editable="data" class="ui-cms-row">
    <UiCmsRichText v-for="item in data.items" :key="item._uid" :data="item" />
  </div>
</template>

<style lang="scss" scoped>
.ui-cms-row {
  padding: 0 $ui-global-padding;
  display: flex;

  @include v2-apply-upto('tablet') {
    flex-direction: column;
  }
}

.ui-cms-row :deep(.ui-cms-rich-text) {
  flex: 1;

  @include v2-apply-upto('tablet') {
    padding: 0;
  }
}
</style>
